import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import { articlesMeta } from "@/mocks/articles";
import { SUPPORTED_LANGS } from "@/i18n/languages";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...SUPPORTED_LANGS.map((lang) => ({
    path: `/${lang}`,
    element: <Home />,
  })),
  ...articlesMeta.map((article) => ({
    path: `/${article.slug}`,
    element: <Article />,
  })),
  ...articlesMeta.flatMap((article) =>
    SUPPORTED_LANGS.map((lang) => ({
      path: `/${lang}/${article.slug}`,
      element: <Article />,
    }))
  ),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;